import request from "../utils/request";
const { swSewagePath, swPatrol } = window.globalConfig;

export default class AnalysisApi {
  /**
   * 大屏 信息总览-出水信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static outWater = (params) => {
    return request.post(`/${swSewagePath}/api/bigScreen/outWater`, params);
  };

  /**
   * 水质分析
   * @param params
   * @returns {*|Promise<*>}
   */
  static selectWaterQuality = (params) => {
    return request.post(
      `/${swSewagePath}/api/dataanalysis/selectWaterQuality`,
      params
    );
  };

  /**
   * 综合评价信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static getComprehensiveInfo = (params) => {
    return request.get(
      `/${swSewagePath}/api/comprehensive/getComprehensiveInfo`,
      params
    );
  };

  /**
   * 更改设备能耗项配置
   * @param params
   * @returns {*|Promise<*>}
   */
  static renewDeviceEnergyConfig = (params) => {
    return request.post(
      `/${swSewagePath}/api/energy/renewDeviceEnergyConfig`,
      params
    );
  };

  /**
   * 获取巡检任务项统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static getPatrolTaskItemStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskItem/getPatrolTaskItemStatistics`,
      params
    );
  };
  /**
   * 获取缺陷单统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDefectOrderStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/defectOrder/getDefectOrderStatistics`,
      params
    );
  };
  /**
   * 获取巡检工单统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static getPatrolWorkOrderStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/workOrder/getPatrolWorkOrderStatistics`,
      params
    );
  };
  /**
   * 获取厂站详细信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static getStationInfo = (params) => {
    return request.get(`/${swSewagePath}/api/comprehensive/getStationInfo`, {
      params,
    });
  };
  /**
   * 获取设备采集变量的默认配置项
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDeviceEnergyIcon = (params) => {
    return request.get(`/${swSewagePath}/api/energy/getDeviceEnergyIcon`, {
      params,
    });
  };
  /**
   * 获取设备能耗详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDeviceEnergyConfigInfo = (params) => {
    return request.get(
      `/${swSewagePath}/api/energy/getDeviceEnergyConfigInfo`,
      { params }
    );
  };
  /**
   * 总体能耗分析
   * @param params
   * @returns {*|Promise<*>}
   */
  static energyCensusOverall = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energyCensusOverall`,
      params
    );
  };
  /**
   * 单体能耗图表
   * @param params
   * @returns {*|Promise<*>}
   */
  static energySingleDeviceChart = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energySingleDeviceChart`,
      params
    );
  };

  /**
   * 单体能耗分析
   * @param params
   * @returns {*|Promise<*>}
   */
  static energySingleDeviceTable = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energySingleDeviceTable`,
      params
    );
  };
  

  /**
   * 能耗总览
   * @param params
   * @returns {*|Promise<*>}
   */
  static energyCensusOverview = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energyCensusOverview`,
      params
    );
  };

  /**
   * 事件报警统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static totalAlarm = (params) => {
    return request.get(`/${swSewagePath}/api/comprehensive/totalAlarm`, params);
  };

  /**
   * 事件报警统计-新
   * @param params
   * @returns {*|Promise<*>}
   */
  static totalAlarmNew = (params) => {
    return request.get(`/${swSewagePath}/api/alarm/totalAlarm`, params);
  };

  /**
   * 缺陷单统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static totalDefaultOrder = (params) => {
    return request.get(
      `/${swSewagePath}/api/comprehensive/totalDefaultOrder`,
      params
    );
  };
	
  /**
   * 设备分类列表
   * @param params
   * @returns {*|Promise<*>}
   */
  static deviceClassifyList = (params) => {
    return request.post(`/${swSewagePath}/api/deviceClassify/list`, params);
  };
  /**
   * 药耗类型
   * @param params
   * @returns {*|Promise<*>}
   */
  static selectYaoTypeList = (params) => {
    return request.get(
      `/${swSewagePath}/api/energy/selectYaoTypeList`,
      params
    );
  };	
  /**
   * 能耗日报表表格
   * @param params
   * @returns {*|Promise<*>}
   */
  static getEnergyDayReportTable = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energyDayReportTable`,
      params
    );
  };

  /**
   * 能耗日报表图表
   * @param params
   * @returns {*|Promise<*>}
   */
  static energyDayReportChart = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/energyDayReportChart`,
      params
    );
  };

  /**
   * 获取所有的站点信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static listEnergyByPage = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/selectEnergyReportList`,
      params
    );
  };
  static getStation = (params) => {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let stationIds = userInfo.stationIds ? userInfo.stationIds.split(",") : [];
    return request.post(
      `/${swSewagePath}/api/station/selectStationNameList`,
      stationIds
    );
  };
  static updateData = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/updateEOrQReport`,
      params
    );
  };
  static exportEnergyData = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/exportEnergyReport`,
      params,
      {
        responseType: "blob",
      }
    );
  };
  static listQualityByPage = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/selectQualityReportList`,
      params
    );
  };
  static exportQualityData = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/exportQualityReport`,
      params,
      {
        responseType: "blob",
      }
    );
  };
  static selectQualityHeadList = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/selectQualityHeadList`,
      params
    );
  };
  static selectYaoReportList = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/selectYaoReportList`,
      params
    );
  };
  static exportYaoReport = (params) => {
    return request.post(
      `/${swSewagePath}/api/stationreport/exportYaoReport`,
      params,
      {
        responseType: "blob",
      }
    );
  };
  static yaoDoseUpdate = (params) => {
    return request.post(`/${swSewagePath}/api/yaoDose/update`, params);
  };
  static selectProcessUnitList = (id) => {
    return request.appid(
      `/${swSewagePath}/api/device/selectProcessUnitList?stationId=${id}`
    );
  };
  static selectDeviceList = (params) => {
    return request.post(`/${swSewagePath}/api/device/selectDeviceList`, params);
  };
  static selectNextDeviceList = (params) => {
    return request.post(
      `/${swSewagePath}/api/device/selectNextDeviceList`,
      params
    );
  };
  static selectEnergyList = (params) => {
    return request.post(
      `/${swSewagePath}/api/energy/selectEnergyList`,
      params
    );
  };
  static selectEnergyDlDyList = (params) => {
    return request.get(
      `/${swSewagePath}/api/energy/selectEnergyDlDyList`,
      params
    );
  };

  static selectEnergyDeviceList = (params) => {
    return request.get(
      `/${swSewagePath}/api/energy/selectEnergyDeviceList`,
      params
    );
  };
  static selectEnergyTotal = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/selectEnergyTotal`,
      params
    );
  };
  static getEnergyReportByEnergy = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/getEnergyReportByEnergy`,
      params
    );
  };
  static getEnergyReportByDevice = (params) => {
    return request.post(
      `/${swSewagePath}/api/energycensus/getEnergyReportByDevice`,
      params
    );
  };
  static getEnergyDlDyPointList = (energyId, params) => {
    return request.get(
      `/${swSewagePath}/api/energy/getEnergyDlDyPointList?energyId=${energyId}`,
      params
    );
  };
  static updateEnergyDlDyPoint = (params) => {
    return request.post(
      `/${swSewagePath}/api/energy/updateEnergyDlDyPoint`,
      params
    );
  };
  // 获取分时控制数据
  static getShartTimeControlAll = (type) => {
    return request.get(
      `/${swSewagePath}/api/carbonSource/getShartTimeControlAll/${type}`
    );
  };
  // 修改分时控制数据
  static editShartTimeControlVal = (params) => {
    return request.post(
      `/${swSewagePath}/api/carbonSource/editShartTimeControlVal`,
      params
    );
  };
}
